import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Captcha from "components/captcha/Captcha";
import PageVersionContext from "components/PageVersionContext";
import Button from "components/templatesComponents/Button";
import Modal, { ModalActions } from "components/templatesComponents/Modal";
import PropTypes from "prop-types";
import React, { useContext, useRef, useState } from "react";
import ContactService from "services/ContactService";
import languages from "utils/languagesTypes";
import t from "utils/locales/translation.json";

const Mailto = (props) => {
  const { text, recipient = "", subject = "", body = "", contentId } = props;
  const { currentPageVersion } = useContext(PageVersionContext);
  const { id: pageId } = currentPageVersion;
  const [loader, setLoader] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const captchaRef = useRef(null);

  const language =
    typeof localStorage !== "undefined" && localStorage.getItem("language") !== "null"
      ? localStorage.getItem("language")
      : Object.keys(languages)[0];

  const onModalClose = () => {
    setOpenModal(false);
    setLoader(false);
    setShowModal(false);
  };

  const checkCaptcha = async (emptyCheck) => {
    if (captchaRef && captchaRef.current) {
      if (!captchaRef.current.verifyCaptchaLoaded()) {
        // if captcha didn't load yet (orange is slow ?) retry in 2s
        setTimeout(() => checkCaptcha(emptyCheck), 2000);
        return;
      }

      const token = await captchaRef.current.getToken();
      if (token === null) {
        setShowModal(true);
        if (!emptyCheck) {
          captchaRef.current.setCaptchaErrorMessage(t[language].components.captcha_error_message);
        }
        return;
      }
      captchaRef.current.setCaptchaErrorMessage("");
      const webmail = await ContactService.getWebmail(contentId, pageId, token);
      if (webmail) {
        window.location.href = webmail;
        onModalClose();
      }
    }
  };
  const sendCandidate = async () => {
    setLoader(true);
    if (process.env.liveidentity_key) {
      if (window) {
        setOpenModal(true);
        // need a timeout because react render isn't immediate :
        // captchaRef is still null while checkCaptcha trigger first...
        setTimeout(() => checkCaptcha(true), 2000);
      }
    } else {
      setShowModal(true);
      if (recipient) {
        window.location.href = `mailto:${recipient}?subject=${subject}&body=${body}`;
      } else {
        const webmail = await ContactService.getWebmail(contentId, pageId);
        if (webmail) {
          window.location.href = webmail;
        }
      }
      setLoader(false);
    }
  };

  return (
    <Stack sx={{ alignItems: "center", justifyContent: "center", pb: 3 }}>
      {process.env.liveidentity_URL && (
        <Modal open={openModal} onClose={onModalClose} sx={{ display: showModal ? "block" : "none" }} size="md">
          <form
            action="/"
            method="POST"
            onSubmit={(e) => {
              e.preventDefault();
              checkCaptcha();
            }}
          >
            <Typography>{t[language].components.captcha_redirect_mail_label}</Typography>
            <Captcha ref={captchaRef} id="sample-captcha" />

            <ModalActions>
              <Button kind="secondary" secondaryColor onClick={onModalClose}>
                {t[language].components.cancel_button_label}
              </Button>
              <Button secondaryColor type="submit">
                {t[language].components.emailto_validate_button_label}
              </Button>
            </ModalActions>
          </form>
        </Modal>
      )}
      <Button secondaryColor onClick={() => sendCandidate()} disabled={loader} sx={{ position: "relative" }}>
        {text}
        {loader && <LinearProgress sx={{ position: "absolute", left: 0, right: 0, bottom: 0 }} />}
      </Button>
    </Stack>
  );
};

Mailto.propTypes = {
  text: PropTypes.string.isRequired,
  recipient: PropTypes.string,
  subject: PropTypes.string,
  body: PropTypes.string,
  contentId: PropTypes.string.isRequired,
};

export default Mailto;
